// extracted by mini-css-extract-plugin
module.exports = {"root":"Gallery_root__EtDiE","stamp":"Gallery_stamp__3_Eyc"};